var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAgenda = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 11.7H3.6V13.5H9.9M14.4 16.2H1.8V6.3H14.4M14.4 1.8H13.5V0H11.7V1.8H4.5V0H2.7V1.8H1.8C1.32261 1.8 0.864773 1.98964 0.527208 2.32721C0.189642 2.66477 0 3.12261 0 3.6V16.2C0 16.6774 0.189642 17.1352 0.527208 17.4728C0.864773 17.8104 1.32261 18 1.8 18H14.4C14.8774 18 15.3352 17.8104 15.6728 17.4728C16.0104 17.1352 16.2 16.6774 16.2 16.2V3.6C16.2 3.12261 16.0104 2.66477 15.6728 2.32721C15.3352 1.98964 14.8774 1.8 14.4 1.8ZM12.6 8.1H3.6V9.9H12.6V8.1Z",
    fill: "#0C3891"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAgenda);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/agenda.89e8bbc2d3a431a1fb14f919222ede71.svg";